module.exports = __webpack_public_path__ + "img/galleria3.a9b777a0.jpg";